import isEmpty from 'lodash/isEmpty'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Flash from '../flash-message'
import * as Redirects from './redirects'

interface RasaSystemStatus {
  isActive: boolean
  message: string
  type: string
}

declare const rasaSystemStatus: RasaSystemStatus

const noStatus: RasaSystemStatus = {
  isActive: false,
  message: '',
  type: 'information',
}

const getSystemStatus = (): RasaSystemStatus => {
  try {
    return rasaSystemStatus
  } catch (error) {
    return noStatus
  }
}

const showSystemMessage = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
  ) => action$.ofType(App.INITIALIZING_APPLICATION)
  .map(() => getSystemStatus())
  .filter((systemStatus: RasaSystemStatus) => systemStatus.isActive)
  .map((systemStatus: RasaSystemStatus) => Flash.showFlashWarning(systemStatus.message))

const oldMenuRedirect = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(App.INITIALIZING_APPLICATION)
  .map(() => Redirects.redirectUrl(history.location.pathname))
  .filter((redirectTo) => !isEmpty(redirectTo))
  .map((redirectTo) => Router.redirect(redirectTo))

export const epic = ReduxObservable.combineEpics(
  oldMenuRedirect,
  showSystemMessage,
)



// WEBPACK FOOTER //
// ./src/components/menu/epic.ts